import * as types from '../types'

const state = {
  pageInfo: {
    currentPage: 1
  }
}

const mutations = {
  [types.PRE_PAGE] (state) {
    --state.pageInfo.currentPage
  },

  [types.NEXT_PAGE] (state) {
    ++state.pageInfo.currentPage
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/wishes.js